<template>
	<div class="auth-box-info">
		<!-- <navBar></navBar> -->
		<div class="auth-box">
			<div v-if="statusType && statusType == 1" class="auth-info auth-status-box">
				<img :src="success" alt="" class="logo-auth-status">
				<p class="auth-title">授权成功</p>
				<p class="auth-tip-small">库存100账号已和您的{{$theme.appName}}账号关联</p>
				<bigBtn :txt="'确定'" @onBtnClick="onBtnClickSuccess"></bigBtn>
			</div>
			<div v-if="statusType && statusType == 2" class="auth-info auth-status-box">
				<img :src="error" alt="" class="logo-auth-status">
				<p class="auth-title">授权失败</p>
				<p class="auth-tip-small">授权失败，请查看账号密码是否有误，账号是否重复</p>
				<bigBtn :txt="'确定'" @onBtnClick="onBtnClickError"></bigBtn>
			</div>
		</div>
	</div>
</template>

<script>
	import navBar from '@/components/navBack'
	import bigBtn from './components/bigBtn'
	import './components/auth.less'
	export default {
		name: "authStatus",
		components: {
			bigBtn,
			navBar
		},
		data () {
			return {
				statusType: this.$route.query.statusType || 1,
				success: require('../../assets/order/icon-auth-success.png'),
				error: require('../../assets/order/icon-auth-error.png'),
			}
		},
		mounted () {
			this.$loading.hide()
		},
		methods: {
			onBtnClickSuccess () {
				console.log('click')
				this.$router.back();
			},
			onBtnClickError () {
				this.$router.back();
			}
		}
	}
</script>